import type {
  IAccountDocument,
  IAccountUploadDocument,
} from './../types/document/models'
import { makeDocumentService } from '~/cynqueModules/factoriesForServices/documents'

export const {
  createDocument: createAccountDocument,
  updateDocument: updateAccountDocument,
  deleteDocument: deleteAccountDocument,
} = makeDocumentService<IAccountDocument, IAccountUploadDocument>(
  '/api/accountdocuments',
  'accountDocument'
)
